import {
  COLOUR_FACET_GROUP,
  MORE_COLOURS,
  MORE_COLOURS_FACET,
  MIX_MATCH,
  MIX_MATCH_GROUP,
  MIX_MATCH_PRODUCT,
} from "./nonActionConstants";

export const REQUEST_SEARCH = "REQUEST_SEARCH";
export const RECEIVE_SEARCH = "RECEIVE_SEARCH";

export const UPDATE_PERSONALISATION_PARAMS = "UPDATE_PERSONALISATION_PARAMS";
export const SET_ADDITIONAL_QUERY_PARAMS = "SET_ADDITIONAL_QUERY_PARAMS";
export const UPDATE_ADDITIONAL_QUERY_PARAMS = "UPDATE_ADDITIONAL_QUERY_PARAMS";

export const MORE_PRODUCTS_LOADED = "MORE_PRODUCTS_LOADED";
export const PREVIOUS_PRODUCTS_LOADED = "PREVIOUS_PRODUCTS_LOADED";
export const LOADING_MORE_PRODUCTS = "LOADING_MORE_PRODUCTS";
export const LOADING_PREVIOUS_PRODUCTS = "LOADING_PREVIOUS_PRODUCTS";
export const SET_NEW_SEARCH = "SET_NEW_SEARCH";
export const CLEAR_NEW_SEARCH = "CLEAR_NEW_SEARCH";
export const DISMISS_FLOOR_FILTER = "DISMISS_FLOOR_FILTER";
export const CLEAR_ON_VIEW_BEACON = "CLEAR_ON_VIEW_BEACON";
export const CLEAR_ON_LOAD_BEACON = "CLEAR_ON_LOAD_BEACON";
export const REFRESH_ADVERTISEMENT_BEACONS = "REFRESH_ADVERTISEMENT_BEACONS";
export const UPDATE_IMAGE_GALLERY_DISMISS = "UPDATE_IMAGE_GALLERY_DISMISS";

export const MOBILE_DONE = "MOBILE_DONE";
export const MOBILE_VIEW_ITEMS = "MOBILE_VIEW_ITEMS";

export const ANCHOR_PRODUCT = "ANCHOR_PRODUCT";

export {
  COLOUR_FACET_GROUP,
  MORE_COLOURS,
  MORE_COLOURS_FACET,
  MIX_MATCH,
  MIX_MATCH_GROUP,
  MIX_MATCH_PRODUCT,
};
export const PRODUCT = "Product";

export const ADVERTISING_PARTNER_QUERY = "advertisementsPartnerId";
export const ADVERTISING_CONSENT_QUERY = "advertisementsOptInConsent";
export const ADVERTISING_VISITOR_QUERY = "advertisementsVisitorId";

export const FEATURES_ID_COOKIE = "featuresId";
